import PropTypes from 'prop-types';
import useAuth from '../../../hooks/useAuth';
import AuthorizationError from '../../../pages/error/AuthorizationError';

const PermissionGaurd = (props) => {
  const { permission, children } = props;
  const { isAuthorized } = useAuth();

  const isAllowed = isAuthorized({ permissionCode: permission });
  if (!isAllowed) {
    return <AuthorizationError />;
  }

  return <>{children}</>;
};

PermissionGaurd.propTypes = {
  children: PropTypes.node,
};

export default PermissionGaurd;
